import React, { useState } from 'react';
import './dashboard-payments-modal-plan.sass';
import { Modal } from '../../../../../components/modal/modal';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { useDispatch, useSelector } from 'react-redux';
import { postChangePlan } from '../../dashboard-plan.slice';
import { getTeamVendorId } from '../../../../login/session.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const DashboardPaymentsModalPlan = ({isVisible, setIsVisible, plans = [], currentPlan}) => {

  const [selectedPlan, setSelectedPlan] = useState(() => plans.find(e => e.id === currentPlan?.plan?.id));
  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session);
  const vendorId = getTeamVendorId(sessionData);

  const onPlanAccept = (plan) => {
    dispatch(postChangePlan({vendorId, planId: plan.id})).then(unwrapResult)
      .then(() => {
        toast.success('plan zmieniony');
        setIsVisible(false);
      }, () => {
        toast.error('coś poszło nie tak');
        setIsVisible(false);
      })
      .catch(e => {
        toast.error(e.message);
        setIsVisible(false);
      });
  };

  const renderPlan = (plan) => {
    return (
      <div className={`vv-payment-plan ${plan === selectedPlan ? 'vv-payment-plan--selected' : ''}`} onClick={() => setSelectedPlan(plan)}>
        <div className='vv-payment-plan__title'>
          <h3>{plan.name}</h3>
        </div>
        <div className='vv-payment-plan__description'><span dangerouslySetInnerHTML={{__html: plan.description}}></span></div>
        <div className='vv-payment-plan__footer'>
          <h3>{plan.price_label}</h3>
        </div>

      </div>
    );
  };

  return <Modal isOpen={isVisible} title='Wybierz plan' setVisible={setIsVisible} width={1000} height={640}>
    <div className='vv-payment-modal'>
      <div className='vv-payment-modal__container'>
        {plans.map(renderPlan)}
      </div>
      <div className='vv-payment-modal__footer'>
        <h3>Chcesz zmienić plan? Skontaktuj sięz nami!</h3>
        {/*<Button type='submit' text='Akceptuj' buttonType={ButtonType.BLACK} size={ButtonSize.VENDOR} onClick={() => onPlanAccept(selectedPlan)}/>*/}
        {/*<Button type='button' text='Anuluj' buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR}*/}
        {/*        onClick={() => setIsVisible(false)}/>*/}
      </div>
    </div>
  </Modal>;
};
